import { Box, useTheme } from '@mui/material';
import type { FC } from 'react';

import type Enums from '@core/types/api/Enums';

type Tab = {
  label: string;
  value: Enums.ProductCategory;
};

type Props = {
  tabs: Tab[];
  activeTab: Enums.ProductCategory;
  setActiveTab: (tab: Enums.ProductCategory) => void;
};

export const CardTabs: FC<Props> = ({ tabs, activeTab, setActiveTab }) => {
  const theme = useTheme();
  if (tabs.length === 0) return null;

  return (
    <Box display='flex'>
      <Box
        sx={{
          display: 'flex',
          gap: 0.5,
          p: 0.5,
          borderRadius: '12px',
          border: `1px solid ${theme.palette.SlabGray.Border}`,
          mb: 1.5,
        }}
      >
        {tabs.map((tab) => (
          <Box
            key={`tab-${tab.value}`}
            onClick={() => setActiveTab(tab.value)}
            sx={{
              px: 1.5,
              py: 0.75,
              borderRadius: '10px',
              cursor: 'pointer',
              fontSize: '0.8rem',
              whiteSpace: 'nowrap',
              transition: 'all 0.15s ease',
              backgroundColor:
                activeTab === tab.value ? theme.palette.SlabGray.Stroke : 'transparent',
              color:
                activeTab === tab.value
                  ? theme.palette.SlabIndigo[700]
                  : theme.palette.SlabGray[600],
              '&:hover': {
                backgroundColor:
                  activeTab === tab.value
                    ? theme.palette.SlabGray.Stroke
                    : theme.palette.SlabGray[50],
              },
            }}
          >
            {tab.label}
          </Box>
        ))}
      </Box>
    </Box>
  );
};
